'use es6';

// Places and hides trap inputs that capture Chrome autofill attempts
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AutofillHoneyPot = () => /*#__PURE__*/_jsxs("div", {
  style: {
    position: 'absolute',
    height: 0,
    overflow: 'hidden'
  },
  children: [/*#__PURE__*/_jsx("input", {
    type: "email",
    name: "browser_autofilled_email"
  }), /*#__PURE__*/_jsx("input", {
    type: "username",
    name: "browser_autofilled_username"
  }), /*#__PURE__*/_jsx("input", {
    type: "password",
    name: "browser_autofilled_password"
  })]
});
export default AutofillHoneyPot;